var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23877 12.0337L10.9678 21.7628C11.284 22.079 11.7981 22.079 12.1142 21.7628C12.4304 21.4466 12.4304 20.9326 12.1142 20.6164L3.76995 12.2721L30.1892 12.2721C30.6368 12.2721 31 11.9088 31 11.4613C31 11.0138 30.6368 10.6505 30.1892 10.6505L3.76995 10.6505L12.1142 2.30624C12.4304 1.99005 12.4304 1.47603 12.1142 1.15984C11.9553 1.00093 11.7478 0.923095 11.5402 0.923095C11.3327 0.923095 11.1251 1.00255 10.9662 1.15984L1.23714 10.8889C0.920949 11.2051 0.920949 11.7191 1.23714 12.0353L1.23877 12.0337Z",
    fill: "#DDDBF1",
    stroke: "#DDDBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrow);
export default __webpack_public_path__ + "static/media/previousArrow.87c69ce1e396635fb672d97b1a9ede95.svg";
export { ForwardRef as ReactComponent };